export default __webpack_public_path__ + "static/media/duster-techroad-gallery-3.8d42d367.jpg";